export interface FeatureConfig { readonly adsEnabled: boolean; readonly debugLoggingEnabled: boolean }
export interface ConfigLogger { warn(message: string, detail?: unknown): void }

export const readFeatureConfig = (source: Readonly<Record<string, unknown>>, production: boolean, logger: ConfigLogger): FeatureConfig => {
  const readBoolean = (key: string, fallback: boolean): boolean => {
    const value = source[key];
    if (value === undefined) return fallback;
    if (typeof value === 'boolean') return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    logger.warn(`Invalid ${key}; using default.`); return fallback;
  };
  return Object.freeze({ adsEnabled: readBoolean('adsEnabled', false), debugLoggingEnabled: readBoolean('debugLoggingEnabled', !production) });
};
